import { render } from "./PaiementForm.vue?vue&type=template&id=98d8b430&scoped=true"
import script from "./PaiementForm.vue?vue&type=script&lang=js"
export * from "./PaiementForm.vue?vue&type=script&lang=js"

import "./PaiementForm.vue?vue&type=style&index=0&id=98d8b430&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d8b430"]])

export default __exports__